import * as React from "react";
import styled from "~/styled";

const CardWrapper = styled.div`
  grid-area: content;

  display: grid;
  grid-row-gap: 12px;
`;

export default class CardList extends React.Component {
  public render() {
    return <CardWrapper>{this.props.children}</CardWrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomerSupport/CardList.tsx